export default function NormalPricing() {
  const services = [
    {
      name: 'Clothes Iron',
      price: 9,
      image: 'https://public.readdy.ai/ai/img_res/b21d5c0d127dba3dcb1aa3dbd38ba040.jpg',
      icon: 'ri-shirt-line'
    },
    {
      name: 'Steem Press',
      price: 15,
      image: 'https://readdy.ai/api/search-image?query=Professional%20steam%20pressing%20machine%20with%20blue%20formal%20garment%20being%20pressed%2C%20commercial%20laundry%20equipment%20in%20action%2C%20clean%20industrial%20setting%2C%20soft%20lighting%20showing%20steam%20and%20fabric%20detail%2C%20high-end%20garment%20care%20service%2C%20simple%20background&width=120&height=120&seq=normal-002&orientation=squarish',
      icon: 'ri-iron-line'
    },
    {
      name: 'Saree Roll Press',
      price: 90,
      image: 'https://readdy.ai/api/search-image?query=Colorful%20traditional%20Indian%20sarees%20neatly%20rolled%20and%20organized%2C%20vibrant%20silk%20fabrics%20in%20red%20green%20gold%20colors%2C%20professional%20saree%20care%20service%2C%20clean%20white%20background%2C%20commercial%20photography%20showing%20rich%20textile%20patterns%20and%20elegant%20draping&width=120&height=120&seq=normal-003&orientation=squarish',
      icon: 'ri-layout-row-line'
    },
    {
      name: 'Dry Cleaning Cloths',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Premium%20dry%20cleaning%20service%20with%20elegant%20formal%20wear%20on%20professional%20hangers%2C%20business%20suits%20and%20delicate%20garments%2C%20clean%20modern%20laundry%20facility%20interior%2C%20soft%20lighting%2C%20high-end%20clothing%20care%2C%20simple%20white%20background%20showing%20quality%20service&width=120&height=120&seq=normal-004&orientation=squarish',
      icon: 'ri-handbag-line'
    },
    {
      name: 'Sari Iron',
      price: 30,
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20traditional%20Indian%20saree%20with%20intricate%20pink%20and%20gold%20embroidery%20patterns%2C%20elegant%20silk%20fabric%20detail%2C%20professional%20saree%20ironing%20service%2C%20clean%20white%20background%2C%20commercial%20photography%20highlighting%20rich%20textile%20work%20and%20delicate%20craftsmanship&width=120&height=120&seq=normal-005&orientation=squarish',
      icon: 'ri-t-shirt-air-line'
    }
  ];

  return (
    <section id="normal-pricing" className="py-24 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-sm font-medium text-amber-600 border border-amber-600/30 px-5 py-2 rounded-full inline-block mb-4">
            Bulk Orders Only
          </span>
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Normal Service Price</h2>
          <p className="text-lg text-gray-600">Minimum order quantity required - Contact us for details</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer border border-gray-100"
            >
              <div className="flex items-start gap-4">
                <div className="relative w-24 h-24 flex-shrink-0 rounded-xl overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{service.name}</h3>
                  <div className="flex items-baseline gap-1">
                    <span className="text-3xl font-bold text-amber-600">₹{service.price}</span>
                    <span className="text-sm text-gray-500">.00</span>
                  </div>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">Per item</span>
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg group-hover:bg-amber-600 transition-colors">
                    <i className={`${service.icon} text-amber-600 group-hover:text-white text-xl transition-colors`}></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 bg-amber-100 px-6 py-3 rounded-full">
            <i className="ri-information-line text-amber-600 text-xl"></i>
            <p className="text-sm text-gray-700">
              <span className="font-semibold">Bulk Orders Only:</span> We accept large quantity orders. Contact us for minimum order requirements
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
